import {
    CurrencyTypesEnum,
    LookupModel,
    PrizeGroupResponseModel,
    PrizeGroupUpdateRequestModel,
    TradingPlanPrizeTypeEnum,
    TradingPlanResponseModel,
    TradingPlanSearchResponseModel,
    TradingPlanStatusEnum,
    TradingPlanSubTypeEnum,
    TradingPlanTypeEnum,
    TradingPlanUpdateRequestModel,
    TradingPlanUsersReportRequestModel,
    TradingPlanUsersReportResponseDataModel
} from '@spa/api';
import {
    AutocompleteOptionInterface,
    DialogButtonTypesEnum,
    DialogConfigInterface,
    RadioGroupOptionInterface,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from 'appShared/components';
import { FilterControlInterface } from 'appShared/interfaces';
import {
    ColorCodesEnum,
    ComponentTypesEnum
} from 'appShared/enums';
import {
    AutocompleteControl,
    BaseControl,
    Helper,
    RadioGroupControl,
    SelectControl,
    SlideToggleControl,
    AmountControl
} from 'appShared/classes';
import { AmountMaxValidator, AmountMinValidator, InArrayValidator } from '@spa/validators';
import { Validators } from '@angular/forms';
import * as moment from 'moment';
export const PanelPlansRequestIdSelector = 'id';
export const PanelPlansStorageId = 'PanelPlansComponent';

export const AvailableCurrencies = [CurrencyTypesEnum.Usd, CurrencyTypesEnum.Euro, CurrencyTypesEnum.Gbp];
const getAvailableCurrenciesAsOptions = (): AutocompleteOptionInterface[] => {
    return AvailableCurrencies.map(x => {
        return {
            label: x.toString(),
            value: x.toString(),
        };
    });
};
export const dailyLeverage = [4, 6];
const getDailyLeverageAsOptions = (): AutocompleteOptionInterface[] => {
    return dailyLeverage.map(x => {
        return {
            label: x.toString(),
            value: x
        };
    });
};
const getHoursAsOptions = (): AutocompleteOptionInterface[] => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
        hours.push(i);
    }

    return hours.map(x => {
        return {
            label: x.toString().padStart(2, '0') + ':00',
            value: x
        };
    });
};

export const getHourControlName = (name: string): string => {
    return name + '_hour';
};
export const OvernightLeverage = [2, 3];
const getOvernightLeverageAsOptions = (): AutocompleteOptionInterface[] => {
    return OvernightLeverage.map(x => {
        return {
            label: x.toString(),
            value: x
        };
    });
};


export const PanelPlansDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Plan ID',
            selector: TradingPlanSearchResponseModel.getReferenceIdSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Status',
            selector: TradingPlanSearchResponseModel.getTradingPlanStatusEnumSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Type',
            selector: TradingPlanSearchResponseModel.getPlanTypeSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Name',
            selector: TradingPlanSearchResponseModel.getNameSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Phase',
            selector: TradingPlanSearchResponseModel.getPhaseSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Bp / Eq',
            selector: TradingPlanSearchResponseModel.getDailyOrEquitySelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Price',
            selector: TradingPlanSearchResponseModel.getPlanPriceSelector(),
            sortable: true
        }),

        new ReportTableColumn({
            label: 'Users',
            selector: TradingPlanSearchResponseModel.getUsersCountSelector(),
            sortable: true
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
};


export const PanelPlansFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: TradingPlanSearchResponseModel.getTradingPlanStatusEnumSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: TradingPlanSearchResponseModel.getTradingPlanStatusEnumSelector(),
                    value: TradingPlanStatusEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getTradingPlanStatusName(TradingPlanStatusEnum.All),
                            value: TradingPlanStatusEnum.All
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanStatusName(TradingPlanStatusEnum.InActive),
                            value: TradingPlanStatusEnum.InActive
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanStatusName(TradingPlanStatusEnum.Purchasable),
                            value: TradingPlanStatusEnum.Purchasable
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanStatusName(TradingPlanStatusEnum.Active),
                            value: TradingPlanStatusEnum.Active
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanStatusName(TradingPlanStatusEnum.Expired),
                            value: TradingPlanStatusEnum.Expired
                        }
                    ]
                })
            ],
            sortIndex: 1
        },
        {
            name: TradingPlanSearchResponseModel.getPlanTypeSelector(),
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: TradingPlanSearchResponseModel.getPlanTypeSelector(),
                    value: TradingPlanTypeEnum.All,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.All),
                            value: TradingPlanTypeEnum.All
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.Demo),
                            value: TradingPlanTypeEnum.Demo
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.Tryout),
                            value: TradingPlanTypeEnum.Tryout,
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.Tournament),
                            value: TradingPlanTypeEnum.Tournament,
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.PrimeTrading),
                            value: TradingPlanTypeEnum.PrimeTrading,
                        },
                        {
                            label: Helper.textsHelper().getTradingPlanTypeName(TradingPlanTypeEnum.FundedAccount),
                            value: TradingPlanTypeEnum.FundedAccount,
                        }
                    ]
                })
            ],
            sortIndex: 2
        },
        {
            name: TradingPlanSearchResponseModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: TradingPlanSearchResponseModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 3

        }
    ];
};


export const PanelPlansDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getTradingPlanStatusEnumSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getPlanTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getPhaseSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getDailyOrEquitySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getPlanPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanSearchResponseModel.getUsersCountSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const CreatePlanControls = (): BaseControl<any>[] => {
    return [
        new BaseControl({
            name: TradingPlanSearchResponseModel.getNameSelector(),
            value: '',
            placeholder: 'Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        }),
        new AutocompleteControl({
            name: TradingPlanSearchResponseModel.getPlanTypeSelector(),
            value: null,
            placeholder: 'Plan Type',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: [],
        }),
        new SlideToggleControl({
            name: TradingPlanSearchResponseModel.getIsDemoSelector(),
            value: false,
            checked: false,
            placeholder: 'Demo',
            validators: [],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),
    ];

};

export interface UpdatePlanFormControlsInterface {
    planType: AutocompleteControl;
    planSubType: AutocompleteControl;
    name: BaseControl;
    tradingPlatformId: AutocompleteControl;
    planPrice: BaseControl;
    planPriceCcy: AutocompleteControl;
    dailyHardBp: BaseControl;
    dailyHardCcy: AutocompleteControl;
    equityAmount: BaseControl;
    equityCcy: AutocompleteControl;
    dailyLeverage: AutocompleteControl;
    overnightLeverage: AutocompleteControl;
    tradingPeriod: BaseControl;
    extendingOneMonthPrice: BaseControl;
    extendingOneMonthPriceCcy: AutocompleteControl;
    dailyLossLimit: BaseControl;
    dailyLossPerPosition: BaseControl;
    maximumTotalLoss: BaseControl;
    dailyPositionAutoClose: SlideToggleControl;
    profitTarget: BaseControl;
    maximumInactivityDays: BaseControl;
    payoutSplit: BaseControl;
    firstWithdrawalDate: BaseControl;
    subsequentWithdrawalDelayDays: BaseControl;
    durationDays: BaseControl;
    payoutMinTradingDays: BaseControl;
    payoutMinAmount: BaseControl;
    planPurchasePeriodStart: BaseControl;
    planPurchasePeriodEnd: BaseControl;
    plansAccountsActivation: BaseControl;
    plansAccountsDeactivation: BaseControl;
    prizeType: AutocompleteControl;
    prizeCcy: AutocompleteControl;
    prizeOfAccumulatedTable: BaseControl;
    prizeMinimum: BaseControl;
    prizeMaximum: BaseControl;
    fixPrize: BaseControl;
    isDemo: SlideToggleControl;
    isDefault: SlideToggleControl;
    planPurchasePeriodStartHour: AutocompleteControl;
    planPurchasePeriodEndHour: AutocompleteControl;
    plansAccountsActivationHour: AutocompleteControl;
    plansAccountsDeactivationHour: AutocompleteControl;
    prizeWinnerCount: SelectControl;
    phase: BaseControl;
    tradingPlanSuccessfulCompletion: AutocompleteControl;
    nextTradingPlanId: AutocompleteControl;
    minimumProfitableDays: BaseControl;
    dailyProfitPerPosition: BaseControl;
    noGamblingRule: SlideToggleControl;
    minimumTradeDuration: BaseControl;
    rewindDailyLossPrice: BaseControl;
    rewindDailyLossPriceCcy: AutocompleteControl;
    previousTradingPlanId: AutocompleteControl;
    isAutoPassAllowed: SlideToggleControl;
    planPriceWithAutoPass: BaseControl;
    planPriceWithAutoPassCcy: AutocompleteControl;
    minTradingDaysTarget: BaseControl;
    minimumTradeRange: BaseControl;
    rewindUsage: BaseControl;
    planUpgradeOption: BaseControl;
    planUpgradeOptionCcy: AutocompleteControl;
    autoPassDeactivationPrice: BaseControl;
    autoPassDeactivationCcy: AutocompleteControl;
    progressFeePercentage: BaseControl;
    nextPlanActivationFeePercentage: BaseControl;
    fastTrackPercentage: BaseControl;
    penaltyPayoutSplit: BaseControl;
    consistencyCoefficientMinimum: BaseControl;
    consistencyCoefficient: BaseControl;
}


export const UpdatePlanControls = (plan: TradingPlanResponseModel,
                                   planTypes: LookupModel,
                                   tradingPlatforms: LookupModel): UpdatePlanFormControlsInterface => {
    return {
       planType:  new AutocompleteControl({
            name: TradingPlanSearchResponseModel.getPlanTypeSelector(),
            value: plan?.planType,
            placeholder: 'Plan Type',
            validators: [
                InArrayValidator(Helper.enumsHelper().getTradingPlanTypeAsOptions(plan.isDemo).map(x => Number(x.value))),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: Helper.enumsHelper().getTradingPlanTypeAsOptions(plan?.isDemo),
            floatingLabelNever: false
        }),
        planSubType: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPlanSubTypeSelector(),
            value: plan?.planSubType,
            placeholder: 'Plan Subtype',
            validators: [
                InArrayValidator(Object.values(TradingPlanSubTypeEnum)),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: Helper.enumsHelper().getTradingPlanSubTypeAsOptions(),
            floatingLabelNever: true
        }),
        name: new BaseControl({
            name: TradingPlanUpdateRequestModel.getNameSelector(),
            value: plan?.name,
            placeholder: 'Plan Name',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        tradingPlatformId: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getTradingPlatformIdSelector(),
            value: plan?.tradingPlatformId,
            placeholder: 'Desktop trading platform',
            validators: [
                InArrayValidator(tradingPlatforms.getTypeKeys().map(x => Number(x))),
            ],
            options: Helper.enumsHelper().getLookupModelasOptions(tradingPlatforms),
            componentType: ComponentTypesEnum.Autocomplete,
            floatingLabelNever: true
        }),
        planPrice: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlanPriceSelector(),
            value: plan?.planPrice,
            placeholder: 'Plan Price',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        planPriceCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPlanPriceCcySelector(),
            value: plan?.planPriceCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        dailyHardBp: new BaseControl({
            name: TradingPlanUpdateRequestModel.getDailyHardBpSelector(),
            value: plan?.dailyHardBp,
            placeholder: 'Daily Hard BP',
            validators: [AmountMaxValidator(9999999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        dailyHardCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getDailyHardCcySelector(),
            value: plan?.dailyHardCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        equityAmount: new BaseControl({
            name: TradingPlanUpdateRequestModel.getEquityAmountSelector(),
            value: plan?.equityAmount,
            placeholder: 'Equity amount',
            validators: [AmountMaxValidator(9999999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        equityCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getEquityCcySelector(),
            value: plan?.equityCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        dailyLeverage: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getDailyLeverageSelector(),
            placeholder: 'Daily leverage',
            value: plan?.dailyLeverage,
            validators: [
                InArrayValidator(dailyLeverage),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getDailyLeverageAsOptions(),
            floatingLabelNever: true
        }),
        overnightLeverage: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getOvernightLeverageSelector(),
            placeholder: 'Overnight leverage',
            value: plan?.overnightLeverage,
            validators: [
                InArrayValidator(OvernightLeverage),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getOvernightLeverageAsOptions(),
            floatingLabelNever: true
        }),
        tradingPeriod: new BaseControl({
            name: TradingPlanUpdateRequestModel.getTradingPeriodSelector(),
            value: plan?.tradingPeriod,
            placeholder: 'Trading period (in days)',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        extendingOneMonthPrice: new BaseControl({
            name: TradingPlanUpdateRequestModel.getExtendingOneMonthPriceSelector(),
            value: plan?.extendingOneMonthPrice,
            placeholder: 'Add Extra month price',
            validators: [AmountMinValidator(0), AmountMaxValidator(9999.99)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        extendingOneMonthPriceCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getExtendingOneMonthPriceCcySelector(),
            value: plan?.extendingOneMonthPriceCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        dailyLossLimit: new AmountControl({
            name: TradingPlanUpdateRequestModel.getDailyLossLimitSelector(),
            value: plan?.dailyLossLimit?.toString(),
            placeholder: 'Daily Loss limit (% of BP or Eq)',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        dailyLossPerPosition: new AmountControl({
            name: TradingPlanUpdateRequestModel.getDailyLossPerPositionSelector(),
            value: plan?.dailyLossPerPosition?.toString(),
            placeholder: 'Daily Loss per position (as % of DL)',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        maximumTotalLoss: new AmountControl({
            name: TradingPlanUpdateRequestModel.getMaximumTotalLossSelector(),
            value: plan?.maximumTotalLoss?.toString(),
            placeholder: 'Maximum total loss (% of BP or Eq)',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        dailyPositionAutoClose: new SlideToggleControl({
            name: TradingPlanUpdateRequestModel.getDailyPositionAutoCloseSelector(),
            value: plan?.dailyPositionAutoClose == null ? false : plan?.dailyPositionAutoClose,
            checked: plan?.dailyPositionAutoClose == null ? false : plan?.dailyPositionAutoClose,
            placeholder: 'Daily position auto-close',
            validators: [],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),
        profitTarget: new AmountControl({
            name: TradingPlanUpdateRequestModel.getProfitTargetSelector(),
            value: plan?.profitTarget?.toString(),
            placeholder: 'Profit target',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        maximumInactivityDays: new BaseControl({
            name: TradingPlanUpdateRequestModel.getMaximumInactivityDaysSelector(),
            value: plan?.maximumInactivityDays,
            placeholder: 'Maximum inactivity days',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        payoutSplit: new AmountControl({
            name: TradingPlanUpdateRequestModel.getPayoutSplitSelector(),
            value: plan?.payoutSplit?.toString(),
            placeholder: 'Payout Split',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        firstWithdrawalDate: new BaseControl({
            name: TradingPlanUpdateRequestModel.getFirstWithdrawalDateSelector(),
            value: plan?.firstWithdrawalDate,
            placeholder: 'First withdrawal date',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        subsequentWithdrawalDelayDays: new BaseControl({
            name: TradingPlanUpdateRequestModel.getSubsequentWithdrawalDelayDaysSelector(),
            value: plan?.subsequentWithdrawalDelayDays,
            placeholder: 'Subsequent Withdrawal',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        durationDays: new BaseControl({
            name: TradingPlanUpdateRequestModel.getDurationDaysSelector(),
            value: plan?.durationDays,
            placeholder: 'Duration Days (days)',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        payoutMinTradingDays: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPayoutMinTradingDaysSelector(),
            value: plan?.payoutMinTradingDays,
            placeholder: 'Payout Min Trading Days (days)',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        payoutMinAmount: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPayoutMinAmountSelector(),
            value: plan?.payoutMinAmount,
            placeholder: 'Payout Min Amount',
            validators: [AmountMinValidator(0), AmountMaxValidator(99999.99)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        planPurchasePeriodStart: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlanPurchasePeriodStartSelector(),
            value: plan?.planPurchasePeriodStart,
            placeholder: 'Plan purchase period start',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true
        }),
        plansAccountsActivation: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlansAccountsActivationSelector(),
            value: plan?.plansAccountsActivation,
            placeholder: 'Plan\’s accounts activation',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true
        }),
        planPurchasePeriodEnd: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlanPurchasePeriodEndSelector(),
            value: plan?.planPurchasePeriodEnd,
            placeholder: 'Plan purchase period еnd',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true
        }),
        plansAccountsDeactivation: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlansAccountsDeactivationSelector(),
            value: plan?.plansAccountsDeactivation,
            placeholder: 'Plan\’s accounts deactivation',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true
        }),
        prizeType: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPrizeTypeSelector(),
            value: plan?.prizeType == null ? null : plan?.prizeType ? 1 : 0,
            placeholder: 'Prize Type',
            validators: [
                InArrayValidator(Object.values(TradingPlanPrizeTypeEnum)),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: Helper.enumsHelper().getTradingPlanPrizeTypeAsOptions(),
            floatingLabelNever: true
        }),
        prizeCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPrizeCcySelector(),
            value: plan?.prizeCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        prizeOfAccumulatedTable: new AmountControl({
            name: TradingPlanUpdateRequestModel.getPrizeOfAccumulatedTableSelector(),
            value: plan?.prizeOfAccumulatedTable?.toString(),
            placeholder: 'Prize % of the accumulated table',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        prizeMinimum: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPrizeMinimumSelector(),
            value: plan?.prizeMinimum,
            placeholder: 'Prize Minimum',
            validators: [AmountMinValidator(0), AmountMaxValidator(99999999.99)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        prizeMaximum: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPrizeMaximumSelector(),
            value: plan?.prizeMaximum,
            placeholder: 'Prize Maximum',
            validators: [AmountMinValidator(0), AmountMaxValidator(99999999.99)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        fixPrize: new BaseControl({
            name: TradingPlanUpdateRequestModel.getFixPrizeSelector(),
            value: plan?.fixPrize,
            placeholder: 'Fix Prize',
            validators: [AmountMinValidator(0), AmountMaxValidator(99999999.99)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        isDemo: new SlideToggleControl({
            name: TradingPlanSearchResponseModel.getIsDemoSelector(),
            value: plan?.isDemo,
            checked: plan?.isDemo,
            placeholder: 'Demo',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),
        isDefault: new SlideToggleControl({
            name: TradingPlanUpdateRequestModel.getIsDefaultSelector(),
            value: plan?.isDefault,
            checked: plan?.isDefault,
            placeholder: 'Default',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),
        planPurchasePeriodStartHour: new AutocompleteControl({
            name: getHourControlName(TradingPlanUpdateRequestModel.getPlanPurchasePeriodStartSelector()),
            value: moment(plan?.planPurchasePeriodStart).utc().hours(),
            placeholder: 'Hour',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getHoursAsOptions(),
            floatingLabelNever: true
        }),
        planPurchasePeriodEndHour: new AutocompleteControl({
            name: getHourControlName(TradingPlanUpdateRequestModel.getPlanPurchasePeriodEndSelector()),
            value: moment(plan?.planPurchasePeriodEnd).utc().hours(),
            placeholder: 'Hour',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getHoursAsOptions(),
            floatingLabelNever: true
        }),
        plansAccountsActivationHour: new AutocompleteControl({
            name: getHourControlName(TradingPlanUpdateRequestModel.getPlansAccountsActivationSelector()),
            value: moment(plan?.plansAccountsActivation).utc().hours(),
            placeholder: 'Hour',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getHoursAsOptions(),
            floatingLabelNever: true
        }),
        plansAccountsDeactivationHour: new AutocompleteControl({
            name: getHourControlName(TradingPlanUpdateRequestModel.getPlansAccountsDeactivationSelector()),
            value: moment(plan?.plansAccountsDeactivation).utc().hours(),
            placeholder: 'Hour',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getHoursAsOptions(),
            floatingLabelNever: true
        }),

        prizeWinnerCount: new SelectControl({
            name: TradingPlanUpdateRequestModel.getPrizeWinnerCountSelector(),
            value: plan?.prizeWinnerCount,
            placeholder: 'Number of Prize Winners',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
            isDynamic: true,
        }),

        phase: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPhaseSelector(),
            value: plan?.phase,
            placeholder: 'Phase',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),

        tradingPlanSuccessfulCompletion: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getTradingPlanSuccessfulCompletionSelector(),
            value: plan?.tradingPlanSuccessfulCompletion,
            placeholder: 'On Plan Successful Completion',
            validators: [
                InArrayValidator(Helper.enumsHelper().getTradingPlanSuccessfulCompletionAsOptions().map(x => Number(x.value))),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: Helper.enumsHelper().getTradingPlanSuccessfulCompletionAsOptions(),
            floatingLabelNever: false
        }),
        nextTradingPlanId: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getNextTradingPlanIdSelector(),
            value: plan?.nextTradingPlanId,
            placeholder: 'Next Plan',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: plan?.nextTradingPlanId !== null ? [
                {
                    label: plan.nextTradingPlanName,
                    value: plan.nextTradingPlanId
                }
            ] : [],
            async: true,
            floatingLabelNever: false
        }),

        minimumProfitableDays:  new BaseControl({
            name: TradingPlanUpdateRequestModel.getMinimumProfitableDaysSelector(),
            value: plan?.minimumProfitableDays,
            placeholder: 'Min profitable days ',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),

        dailyProfitPerPosition:  new AmountControl({
            name: TradingPlanUpdateRequestModel.getDailyProfitPerPositionSelector(),
            value: plan?.dailyProfitPerPosition?.toString(),
            placeholder: 'Max daily position profit as % of PT',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),

        noGamblingRule:  new SlideToggleControl({
            name: TradingPlanUpdateRequestModel.getNoGamblingRuleSelector(),
            value: plan?.noGamblingRule,
            checked: plan?.noGamblingRule,
            placeholder: 'No Gambling Rule',
            validators: [],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),

        minimumTradeDuration:  new BaseControl({
            name: TradingPlanUpdateRequestModel.getMinimumTradeDurationSelector(),
            value: plan?.minimumTradeDuration,
            placeholder: 'Minimum trade duration (in seconds)',
            validators: [AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),

        rewindDailyLossPrice:  new BaseControl({
            name: TradingPlanUpdateRequestModel.getRewindDailyLossPriceSelector(),
            value: plan?.rewindDailyLossPrice,
            placeholder: 'rewind Daily Loss price',
            validators: [],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),

        rewindDailyLossPriceCcy:   new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getRewindDailyLossPriceCcySelector(),
            value: plan?.rewindDailyLossPriceCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),

        previousTradingPlanId: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPreviousTradingPlanIdSelector(),
            value: plan?.previousTradingPlanId,
            placeholder: 'Previous Plan',
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: plan?.previousTradingPlanId !== null ? [
                {
                    label: plan.previousTradingPlanName,
                    value: plan.previousTradingPlanId
                }
            ] : [],
            async: true,
            floatingLabelNever: false
        }),

        isAutoPassAllowed: new SlideToggleControl({
            name: TradingPlanUpdateRequestModel.getIsAutoPassAllowedSelector(),
            value: plan?.isAutoPassAllowed,
            checked: plan?.isAutoPassAllowed,
            placeholder: 'Auto Pass allowed',
            validators: [],
            componentType: ComponentTypesEnum.SlideToggle,
            expectBooleanValue: true,
            color: ColorCodesEnum.Primary
        }),

        planPriceWithAutoPass: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlanPriceWithAutoPassSelector(),
            value: plan?.planPriceWithAutoPass,
            placeholder: 'Plan Price (with Auto Pass ON)',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        planPriceWithAutoPassCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPlanPriceWithAutoPassCcySelector(),
            value: plan?.planPriceWithAutoPassCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        minTradingDaysTarget: new BaseControl({
            name: TradingPlanUpdateRequestModel.getMinTradingDaysTargetSelector(),
            value: plan?.minTradingDaysTarget,
            placeholder: 'Min Trading days',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        minimumTradeRange: new BaseControl({
            name: TradingPlanUpdateRequestModel.getMinimumTradeRangeSelector(),
            value: plan?.minimumTradeRange,
            placeholder: 'Minimum Trade Range',
            validators: [AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),

        rewindUsage: new BaseControl({
            name: TradingPlanUpdateRequestModel.getRewindUsageSelector(),
            value: plan?.rewindUsage,
            placeholder: '# of times rewind can be used',
            validators: [AmountMinValidator(0), AmountMaxValidator(Number.MAX_SAFE_INTEGER)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        planUpgradeOption: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPlanUpgradeOptionSelector(),
            value: plan?.planUpgradeOption,
            placeholder: 'Plan Upgrade Option',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        planUpgradeOptionCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getPlanUpgradeOptionCcySelector(),
            value: plan?.planUpgradeOptionCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        autoPassDeactivationPrice: new BaseControl({
            name: TradingPlanUpdateRequestModel.getAutoPassDeactivationPriceSelector(),
            value: plan?.autoPassDeactivationPrice,
            placeholder: 'Auto Pass deactivation',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        autoPassDeactivationCcy: new AutocompleteControl({
            name: TradingPlanUpdateRequestModel.getAutoPassDeactivationCcySelector(),
            value: plan?.autoPassDeactivationCcy,
            placeholder: 'CCY',
            validators: [
                InArrayValidator(AvailableCurrencies),
            ],
            componentType: ComponentTypesEnum.Autocomplete,
            options: getAvailableCurrenciesAsOptions(),
            floatingLabelNever: true
        }),
        progressFeePercentage: new AmountControl({
            name: TradingPlanUpdateRequestModel.getProgressFeePercentageSelector(),
            value: plan?.progressFeePercentage?.toString(),
            placeholder: 'Progress Fee',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        nextPlanActivationFeePercentage: new AmountControl({
            name: TradingPlanUpdateRequestModel.getNextPlanActivationFeePercentageSelector(),
            value: plan?.nextPlanActivationFeePercentage?.toString(),
            placeholder: 'Next Plan auto activation fee',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        fastTrackPercentage: new AmountControl({
            name: TradingPlanUpdateRequestModel.getFastTrackPercentageSelector(),
            value: plan?.fastTrackPercentage?.toString(),
            placeholder: 'Fast Track',
            validators: [AmountMinValidator(0), AmountMaxValidator(100.00)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true,
            isPercentage: true,
            currency: null
        }),
        penaltyPayoutSplit: new BaseControl({
            name: TradingPlanUpdateRequestModel.getPenaltyPayoutSplitSelector(),
            value: plan?.penaltyPayoutSplit,
            placeholder: 'Penalty Payout Split',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0.01)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        consistencyCoefficientMinimum: new BaseControl({
            name: TradingPlanUpdateRequestModel.getConsistencyCoefficientMinimumSelector(),
            value: plan?.consistencyCoefficientMinimum,
            placeholder: 'Consistency coefficient',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0.01)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
        consistencyCoefficient: new BaseControl({
            name: TradingPlanUpdateRequestModel.getConsistencyCoefficientSelector(),
            value: plan?.consistencyCoefficient,
            placeholder: 'Consistency coefficient',
            validators: [AmountMaxValidator(99999999.99), AmountMinValidator(0.01)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: true
        }),
    };

};
export const PrizeWinnerDefaultOptions = [3, 10, 20, 50, 100];

export const PanelPlansUsersPeriodSelector = 'PanelPlansUsersPeriod';

export const PanelPlanUsersFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: PanelPlansUsersPeriodSelector,
            placeholder: 'Period',
            controls: [
                new BaseControl({
                    name: TradingPlanUsersReportRequestModel.getPeriodStartDateSelector(),
                    value: null,
                    placeholder: 'Period from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: TradingPlanUsersReportRequestModel.getPeriodEndDateSelector(),
                    value: null,
                    placeholder: 'Period to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 1
        }
    ];
};

export const PanelPlanUsersDataTableFilteredColumns = [
    TradingPlanUsersReportResponseDataModel.getPnlFromSelector(),
    TradingPlanUsersReportResponseDataModel.getPnlToSelector(),
    TradingPlanUsersReportResponseDataModel.getPortfolioFromSelector(),
    TradingPlanUsersReportResponseDataModel.getPortfolioToSelector(),
    TradingPlanUsersReportResponseDataModel.getRankChangeSelector()
];
export const PanelPlanUsersDataTableUnFilteredColumns = [
    TradingPlanUsersReportResponseDataModel.getPnlSelector(),
    TradingPlanUsersReportResponseDataModel.getPortfolioSelector()

];

export const AddPlanDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const TradingPlanStatusesControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: TradingPlanSearchResponseModel.getTradingPlanStatusEnumSelector(),
        value: null,
        placeholder: 'Status',
        validators: [
            Validators.required
        ],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: []
    });
};

export const TradingPlanStatusControlOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.InActive
            ),
            value: TradingPlanStatusEnum.InActive,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.Set
            ),
            value: TradingPlanStatusEnum.Set,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.Purchasable
            ),
            value: TradingPlanStatusEnum.Purchasable,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.OnHold
            ),
            value: TradingPlanStatusEnum.OnHold,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.ActiveAndPurchasable
            ),
            value: TradingPlanStatusEnum.ActiveAndPurchasable,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.Active
            ),
            value: TradingPlanStatusEnum.Active,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingPlanStatusName(
                TradingPlanStatusEnum.Expired
            ),
            value: TradingPlanStatusEnum.Expired,
            color: ColorCodesEnum.Primary
        }
    ];
};

export const PrizeGroupGroupPercentageSelector = 'PrizeGroupGroupPercentage';

export const PrizeGroupControls = (model: PrizeGroupResponseModel): BaseControl<any>[] => {
    return [
        new BaseControl({
            name: PrizeGroupUpdateRequestModel.getStartPositionSelector(),
            value: model?.start_position,
            placeholder: 'Start',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: false
        }),
        new BaseControl({
            name: PrizeGroupUpdateRequestModel.getEndPositionSelector(),
            value: model?.end_position,
            placeholder: 'End',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: false
        }),
        new BaseControl({
            name: PrizeGroupUpdateRequestModel.getPerPositionSelector(),
            value: model?.per_position,
            placeholder: 'Per Position',
            validators: [Validators.required, AmountMinValidator(0), AmountMaxValidator(100)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: false
        }),
        new BaseControl({
            name: PrizeGroupGroupPercentageSelector,
            value: model != null ? model?.getPositionsCount() * model?.per_position : null,
            placeholder: 'For The Group',
            validators: [Validators.required, AmountMinValidator(0), AmountMaxValidator(100)],
            componentType: ComponentTypesEnum.AmountInput,
            floatingLabelNever: false
        }),
    ];

};

export const AddPrizeDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const PanelPlanUsersDataTableItems = (): ReportTableData[] => {
    return[
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getCreatedDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getLastLoginSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getLastTradeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getTradeCountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getVolumeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPnlSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPnlFromSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPnlToSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPortfolioSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPortfolioFromSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getPortfolioToSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getRankSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getRankChangeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlanUsersReportResponseDataModel.getSubscriptionStatusSelector(),
            value: null,
            hidden: false
        }),
    ];

};
export const PanelPlanUsersDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingPlanUsersReportResponseDataModel.getAccountReferenceIdSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: TradingPlanUsersReportResponseDataModel.getNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Create Date',
                selector: TradingPlanUsersReportResponseDataModel.getCreatedDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: TradingPlanUsersReportResponseDataModel.getEmailSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Last Login',
                selector: TradingPlanUsersReportResponseDataModel.getLastLoginSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Last Trade',
                selector: TradingPlanUsersReportResponseDataModel.getLastTradeSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'Trades',
                selector: TradingPlanUsersReportResponseDataModel.getTradeCountSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'Volume',
                selector: TradingPlanUsersReportResponseDataModel.getVolumeSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PnL',
                selector: TradingPlanUsersReportResponseDataModel.getPnlSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PnL (from)',
                selector: TradingPlanUsersReportResponseDataModel.getPnlFromSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PnL (to)',
                selector: TradingPlanUsersReportResponseDataModel.getPnlToSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PF',
                selector: TradingPlanUsersReportResponseDataModel.getPortfolioSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PF (from)',
                selector: TradingPlanUsersReportResponseDataModel.getPortfolioFromSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'PF (to)',
                selector: TradingPlanUsersReportResponseDataModel.getPortfolioToSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: '#',
                selector: TradingPlanUsersReportResponseDataModel.getRankSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: '#',
                selector: TradingPlanUsersReportResponseDataModel.getRankChangeSelector(),
                sortable: false
            }),
            new ReportTableColumn({
                label: 'Is Sub-R',
                selector: TradingPlanUsersReportResponseDataModel.getSubscriptionStatusSelector(),
                sortable: true
            }),
        ],
        hiddenColumnIds: [...PanelPlanUsersDataTableUnFilteredColumns],
        actionMenu: false
    };
};
